import React from "react";
import ReactDOM from "react-dom";
import Home from "./containers/home/Home";
import firebase from "firebase/app";
import firestore from "firebase/firestore"
import registerServiceWorker from "./registerServiceWorker";
import { convertToRaw, convertFromRaw, EditorState } from "draft-js";
import { BrowserRouter as Router } from "react-router-dom";
import config from "./FBconfig.js";

// MY UTILITY FUNCTIONS
import {
  makeGetFullBook,
  makeCreateSection,
  makeDeleteSection,
  makeSaveText,
  makeReadText
} from "./firebaseFunctions/firebaseFunctions.js";

import {
  makeTextToRaw,
  makeRawToText
} from "./draftFunctions/draftFunctions.js";


firebase.initializeApp(config);
const db = firebase.firestore();
const settings = {/* your settings... */ timestampsInSnapshots: true};
db.settings(settings);


// FB functions
const getFullBook = makeGetFullBook(db);
const createSection = makeCreateSection(db);
const deleteSection = makeDeleteSection(db);
const saveText = makeSaveText(db);
const readText = makeReadText(db);

//draft functions
const textToRaw = makeTextToRaw(convertToRaw);
const rawToText = makeRawToText(convertFromRaw, EditorState);

// Utils obj
const utils = {
  fb: {
    getFullBook,
    createSection,
    deleteSection,
    saveText,
    readText 
  },
  draft: {
    textToRaw,
    rawToText
  }
}

const App = () => (
  <Router>
    <Home utils={utils} />
  </Router>
);

ReactDOM.render(<App />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js